import { combineReducers } from 'redux';
import { IPerson, IPersonValues, ITeamValues } from 'types/registration';
import { ActionType, getType } from 'typesafe-actions';
import * as eventsActions from '../events/actions';
import { EventsAction } from '../events/reducer';
import * as actions from './actions';

export interface IRegsitrationState {
  readonly errors: {
    event?: string;
    team: ITeamValues;
    captain: IPersonValues;
    players: {
      [key: string]: IPersonValues;
    };
    playersError?: string;
    reserves: {
      [key: string]: IPersonValues;
    };
    reservesError?: string;
  };
  readonly eventsToLoad: number;
  readonly event: {
    id: string;
    name: string;
  } | null;
  readonly team: {
    name: string;
    province?: string;
    stadium?: string;
  };
  readonly captain: IPerson;
  readonly players: IPerson[];
  readonly reserves: IPerson[];
  readonly submitting: boolean;
  readonly error: string;
}

export type RegistrationActions = ActionType<typeof actions>;

const EVENTS_TO_LOAD = 3;

const initialState: IRegsitrationState = {
  captain: {
    contact: '',
    email: '',
    name: '',
    surname: ''
  },
  error: '',
  errors: {
    captain: {},
    players: {},
    reserves: {},
    team: {}
  },
  event: null,
  eventsToLoad: EVENTS_TO_LOAD,
  players: [],
  reserves: [],
  submitting: false,
  team: {
    name: ''
  }
};

// const initialState: IRegsitrationState = {
//   captain: {
//     contact: '0848476967',
//     email: 'me@tristanbrandt.io',
//     name: 'Tristan',
//     surname: 'Brandt'
//   },
//   error: '',

//   errors: {
//     captain: {},
//     players: {},
//     reserves: {},
//     team: {}
//   },

//   event: { id: 'test', name: 'test' },
//   eventsToLoad: EVENTS_TO_LOAD,

//   players: [
//     {
//       contact: '0848476967',
//       email: 'me@tristanbrandt.io',
//       name: 'Tristan',
//       surname: 'Brandt'
//     },
//     {
//       contact: '0848476967',
//       email: 'me@tristanbrandt.io',
//       name: 'Tristan',
//       surname: 'Brandt'
//     },
//     {
//       contact: '0848476967',
//       email: 'me@tristanbrandt.io',
//       name: 'Tristan',
//       surname: 'Brandt'
//     },
//     {
//       contact: '0848476967',
//       email: 'me@tristanbrandt.io',
//       name: 'Tristan',
//       surname: 'Brandt'
//     }
//   ],
//   reserves: [],
//   submitting: false,
//   team: {
//     name: 'test',
//     province: 'test',
//     stadium: 'test'
//   }
// };

export default combineReducers<
  IRegsitrationState,
  RegistrationActions | EventsAction
>({
  captain: (state = initialState.captain, action) => {
    if (action.type === getType(actions.resetForm)) {
      return initialState.captain;
    }
    if (
      action.type === getType(actions.updatePerson) &&
      action.payload.person === 'captain'
    ) {
      return {
        ...state,
        ...action.payload.details
      };
    }
    return state;
  },
  error: (state = initialState.error, action) => {
    if (action.type === getType(actions.resetForm)) {
      return initialState.error;
    }
    switch (action.type) {
      case getType(actions.setError): {
        return action.payload.error;
      }
    }
    return state;
  },
  errors: (state = initialState.errors, action) => {
    if (action.type === getType(actions.setErrors)) {
      return {
        ...state,
        ...action.payload
      };
    }
    return state;
  },
  event: (state = initialState.event, action) => {
    if (action.type === getType(actions.resetForm)) {
      return initialState.event;
    }
    if (action.type === getType(actions.setEvent)) {
      return action.payload;
    }
    return state;
  },
  eventsToLoad: (state = initialState.eventsToLoad, action) => {
    switch (action.type) {
      case getType(actions.incrementEvents): {
        return state + EVENTS_TO_LOAD;
      }
      case getType(eventsActions.setCountry): {
        return initialState.eventsToLoad;
      }
      default: {
        return state;
      }
    }
  },
  players: (state = initialState.players, action) => {
    if (action.type === getType(actions.resetForm)) {
      return initialState.players;
    }
    switch (action.type) {
      case getType(actions.addPerson): {
        if (action.payload.type === 'player') {
          return [
            ...state,
            {
              contact: '',
              email: '',
              name: '',
              surname: ''
            }
          ];
        }
        return state;
      }
      case getType(actions.updatePerson): {
        if (typeof action.payload.person === 'object') {
          if (action.payload.person.type === 'player') {
            const newPlayers = [...state];
            newPlayers[action.payload.person.index] = {
              ...newPlayers[action.payload.person.index],
              ...action.payload.details
            };
            return newPlayers;
          }
        }
        return state;
      }
      case getType(actions.removePerson): {
        if (action.payload.type === 'player') {
          const newPlayers = [...state];
          newPlayers.splice(action.payload.index, 1);
          return newPlayers;
        }
        return state;
      }
      default: {
        return state;
      }
    }
  },
  reserves: (state = initialState.reserves, action) => {
    if (action.type === getType(actions.resetForm)) {
      return initialState.reserves;
    }
    switch (action.type) {
      case getType(actions.addPerson): {
        if (action.payload.type === 'reserve') {
          return [
            ...state,
            {
              contact: '',
              email: '',
              name: '',
              surname: ''
            }
          ];
        }
        return state;
      }
      case getType(actions.updatePerson): {
        if (typeof action.payload.person === 'object') {
          if (action.payload.person.type === 'reserve') {
            const newReserves = [...state];
            newReserves[action.payload.person.index] = {
              ...newReserves[action.payload.person.index],
              ...action.payload.details
            };
            return newReserves;
          }
        }
        return state;
      }
      case getType(actions.removePerson): {
        if (action.payload.type === 'reserve') {
          const newReserves = [...state];
          newReserves.splice(action.payload.index, 1);
          return newReserves;
        }
        return state;
      }
      default: {
        return state;
      }
    }
  },
  submitting: (state = initialState.submitting, action) => {
    switch (action.type) {
      case getType(actions.setSubmitting): {
        return action.payload.submitting;
      }
    }
    return state;
  },
  team: (state = initialState.team, action) => {
    if (action.type === getType(actions.resetForm)) {
      return initialState.team;
    }
    if (action.type === getType(actions.setTeam)) {
      return {
        ...state,
        ...action.payload
      };
    }
    return state;
  }
});



// WEBPACK FOOTER //
// ./src/store/modules/registration/reducer.ts